import { type CreateRecordTriggerConfig, TooltipText } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import { useDataSourceOptions } from '@/hooks/useDataSource'

import * as CM from '../styles'
import * as SC from './styles'

type CreateRecordCardProps = {
    config: CreateRecordTriggerConfig
}

const CreateRecordCard: React.FC<CreateRecordCardProps> = ({ config }) => {
    const options = useDataSourceOptions()

    const option = useMemo(
        () => (config?.dataSourceId ? options.find(item => item.value === config.dataSourceId) : undefined),
        [config.dataSourceId, options]
    )

    if (!option) {
        return null
    }

    return (
        <CM.CardItemContainer>
            <SC.TypeName>当记录被创建时</SC.TypeName>
            <CM.FieldList>
                <CM.FieldItem>
                    <CM.FieldItemLeftFill>
                        <SC.Icon type={option?.icon ?? ''} />
                        <TooltipText
                            title={option?.label}
                            render={ref => <CM.FieldItemTitle ref={ref}>{option?.label}</CM.FieldItemTitle>}
                        />
                    </CM.FieldItemLeftFill>
                </CM.FieldItem>
            </CM.FieldList>
        </CM.CardItemContainer>
    )
}

export default CreateRecordCard
